/* eslint-disable */
const mutations = {
  setOrderMethods(state, { orderMethods }) {
    state.data = orderMethods;
  },
};

export default mutations;
